import request from '@/utils/request'
import { fileService } from "@/api/common/file-utils";
export default {
    getList: (data) => {
        return request({
            url: 'capacity',
            method: 'post',
            data: data,
        })
    },
    saveCapacity: (data) => {
        return request({
            url: 'capacity/save',
            method: 'post',
            data: data,
        })
    },
    newCapacityInfo: (data) => {
        return request({
            url: 'capacity/newCapacityInfo',
            method: 'post',
            data: data,
        })
    },
    capacityInfo: (data) => {
        return request({
            url: 'capacity/capacityInfo',
            method: 'post',
            data: data,
        })
    },
    saveCapacityDetail: (data) => {
        return request({
            url: 'capacity/saveSup',
            method: 'post',
            data: data,
        })
    },
    //模板下载
    templateDownload: (data) => request({
        url: 'capacity/templateDownload',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: data
    }).then(resp => {
        console.log(resp)
        fileService.respToFile(resp, '供应商产能利用率总览.xlsx');
    }),
    download: (data) => {
        return request({
            url: `capacity/export`,
            method: 'post',
            data: data,
            responseType: 'blob',
            fullResponse: true
        }).then(fileService.respToFile);
    },
    fileUpload: (file, id) => {
        return request({
            url: `/capacity/import?ttSupplierCapacityId=${id}`,
            // url: `/capacity/import/${id}`,
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data; charset=UTF-8'
            },
            data: file
        })
    },
    getTemplate: (data) => {
        return request({
            url: 'capacityTemplate',
            method: 'post',
        })
    },
    saveTemplate: (data) => {
        return request({
            url: 'capacityTemplate/save',
            method: 'post',
            data: data,
        })
    },
    //压缩文件下载
    zipDownload: (data) => request({
        url: 'capacity/downloadAll',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: data
    }).then(resp => {
        fileService.respToFile(resp, '供应商产能产能配置与利用率.zip');
    }),
    //产能页面得到模板信息
    getTemplateByCapacity: (data) => {
        return request({
            url: 'capacity/template',
            method: 'post',
            data: data
        })
    },
}